import { motion } from 'framer-motion';
import { Code, Palette, Rocket, Zap, Shield, Headphones } from 'lucide-react';

export const Services = () => {
  const services = [
    {
      icon: <Code className="w-8 h-8" />,
      title: 'Custom Web Development',
      description: 'Bespoke websites built with modern tech stacks for performance and scalability.',
    },
    {
      icon: <Palette className="w-8 h-8" />,
      title: 'UI/UX Design',
      description: 'Beautiful, intuitive interfaces that enhance user experience and drive conversions.',
    },
    {
      icon: <Rocket className="w-8 h-8" />,
      title: 'Brand Identity',
      description: 'Complete branding solutions including logos, color palettes, and style guides.',
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: 'Performance Optimization',
      description: 'Lightning-fast websites optimized for speed, SEO, and Core Web Vitals.',
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: 'Secure & Reliable',
      description: 'Enterprise-grade security with SSL, regular backups, and 99.9% uptime.',
    },
    {
      icon: <Headphones className="w-8 h-8" />,
      title: '24/7 Support',
      description: 'Dedicated support team available round the clock for all your needs.',
    },
  ];

  return (
    <section id="services" className="py-24 md:py-32 relative overflow-hidden" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#007AFF] mb-4 block" data-testid="services-label">
            What We Do
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }} data-testid="services-title">
            Services Built for{' '}
            <span className="bg-gradient-to-r from-[#007AFF] to-[#00F0FF] bg-clip-text text-transparent">
              Your Success
            </span>
          </h2>
          <p className="text-zinc-400 max-w-2xl mx-auto leading-relaxed" data-testid="services-description">
            We offer end-to-end web solutions that help businesses establish a powerful online presence
            and achieve their digital goals.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className="glass-card p-8 rounded-2xl hover:border-[#007AFF] transition-all cursor-hover group"
              data-testid={`service-card-${index}`}
            >
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#007AFF] to-[#00F0FF] flex items-center justify-center mb-6 text-white group-hover:scale-110 transition-transform">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3" data-testid={`service-title-${index}`}>
                {service.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed" data-testid={`service-description-${index}`}>
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};